require('./registration-forms/agendaeventregistrationform');
require('./registration-forms/distribution');
require('./bootstrap');
require('./album');
require('./donation');
require('./donation-notes');
require('./faders');
require('./glide');
require('./menu');
require('./sliders');
require('./typewriter');
